import { HttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';

import SessionManager from './util/sessionManager';

const httpLink: ApolloLink = new HttpLink({ uri: SessionManager.urlRouter.graphQLUrl });

export default httpLink;
